export const openPositions = [
  {
    id: "junior-data-scientist",
    title: "Junior Data Scientist",
    description: "Turn data into business power. Help clients automate, analyze, and make smarter decisions.",
    location: "Žilina, Slovakia or Remote in Slovakia or Czechia.",
    contract: "Full Time, Contract",
    applyLink: "https://docs.google.com/forms/d/e/1FAIpQLScbHQW9Lni3eC1edZoQP8BIkLZu1Lb8Fc8Yaj56HNbwu5viMw/viewform?usp=header",
    introduction: {
      title: "Introduction",
      content: "We are seeking a motivated and analytical Junior Data Scientist to join our dynamic team. This entry-level position is perfect for individuals eager to advance their career in the field of data science and analytics, utilizing industry-leading tools and technologies."
    },
    hiringProcess: {
      title: "Our Hiring Process",
      steps: [
        { title: 'Apply', description: 'Submit your CV. We review every application.' },
        { title: 'First Interview', description: 'The Online interview with your future colleague.' },
        { title: 'Take-home challenge', description: 'A practical assignment reflecting our work.' },
        { title: 'Challenge Review', description: 'An Online chat with your future manager and colleagues about your take-home challenge.' },
        { title: 'Second Interview', description: 'The Online interview with one of the founders to discuss your fit and future goals.' },
        { title: 'Offer', description: "If it's a fit, we'll extend a warm welcome!" },
      ]
    },
    responsibilities: [
        "Develop and implement data processing pipelines, machine learning models and algorithms using Python.",
        "Efficiently query and manipulate large datasets using SQL.",
        "Work with spreadsheets to automate various data processes.",
        "Design and create reports using PowerBI to aid strategic decision-making.",
        "Collaborate with cross-functional teams to understand data needs and deliver scalable solutions.",
        "Participate in the development and maintenance of data pipelines and architectures.",
        "Assist in the integration of cloud technologies (AWS, Azure, Google Cloud) to enhance data processing and analytics capabilities."
    ],
    qualifications: [
        "Strong proficiency in Python, with a good understanding of libraries like pandas, NumPy, and scikit-learn.",
        "Experience with SQL and relational databases.",
        "Familiarity with spreadsheet tools such as Microsoft Excel or Google Sheets.",
        "Basic knowledge of data visualization and reporting tools like PowerBI.",
        "Enthusiasm for and a basic understanding of cloud services (AWS, Azure, Google Cloud).",
        "Excellent analytical and problem-solving abilities.",
        "Strong communication and collaboration skills.",
        "Experience with BigQuery and dbt is considered a strong plus.",
        "Prior exposure to machine learning or data engineering projects is a plus."
    ],
  },
  {
    id: "junior-software-engineer",
    title: "Junior Software Engineer",
    description: "Build the tools and automations that power data-driven business transformation.",
    location: "Žilina, Slovakia or Remote in Slovakia or Czechia.",
    contract: "Full Time, Contract",
    applyLink: "https://docs.google.com/forms/d/e/1FAIpQLSe3xAGIcUdm2rBsyNBULc_lWr7DE-rHaRFlpTIsivlKEiXafA/viewform?usp=header",
    introduction: {
      title: "Introduction",
      content: "We are looking for a creative and skilled Junior Software Engineer to join our innovative team. This entry-level role is perfect for someone passionate about building robust software solutions and automations that directly support our data-driven projects and client needs."
    },
    hiringProcess: {
      title: "Our Hiring Process",
      steps: [
        { title: 'Apply', description: 'Submit your CV. We review every application.' },
        { title: 'First Interview', description: 'The Online interview with your future colleague.' },
        { title: 'Take-home challenge', description: 'A practical assignment reflecting our work.' },
        { title: 'Challenge Review', description: 'An Online chat with your future manager and colleagues about your take-home challenge.' },
        { title: 'Second Interview', description: 'The Online interview with one of the founders to discuss your fit and future goals.' },
        { title: 'Offer', description: "If it's a fit, we'll extend a warm welcome!" },
      ]
    },
    responsibilities: [
        "Design, develop, and maintain software applications and automation tools.",
        "Collaborate with data scientists and engineers to integrate data-driven features into our products.",
        "Write clean, efficient, and well-documented code.",
        "Participate in code reviews and contribute to a high-quality codebase."
    ],
    qualifications: [
        "Bachelor's degree in Computer Science or a related field.",
        "Proficiency in following programming languages (Python, JavaScript, Typescript).",
        "Experience with web development frameworks (e.g., React, Vue, or Svelte).",
        "Understanding of software development best practices.",
        "Basic knowledge of cloud services (AWS, Azure, Google Cloud).",
        "Excellent communication and collaboration skills."
    ]
  },
  {
    id: "junior-data-engineer",
    title: "Junior Data Engineer",
    description: "Design and build the data pipelines and infrastructure that enable business intelligence at scale.",
    location: "Žilina, Slovakia or Remote in Slovakia or Czechia.",
    contract: "Full Time, Contract",
    applyLink: "https://docs.google.com/forms/d/e/1FAIpQLScM04XrqGF4qv4sXQkbAimki8T9qoxtCQPOI7-y8Myou3lR8A/viewform?usp=header",
    introduction: {
      title: "Introduction",
      content: "We are seeking a motivated and detail-oriented Junior Data Engineer to join our growing team. This entry-level position is ideal for individuals passionate about building and maintaining the scalable data infrastructure that powers modern analytics and data science."
    },
    hiringProcess: {
      title: "Our Hiring Process",
      steps: [
        { title: 'Apply', description: 'Submit your CV. We review every application.' },
        { title: 'First Interview', description: 'The Online interview with your future colleague.' },
        { title: 'Take-home challenge', description: 'A practical assignment reflecting our work.' },
        { title: 'Challenge Review', description: 'An Online chat with your future manager and colleagues about your take-home challenge.' },
        { title: 'Second Interview', description: 'The Online interview with one of the founders to discuss your fit and future goals.' },
        { title: 'Offer', description: "If it's a fit, we'll extend a warm welcome!" },
      ]
    },
    responsibilities: [
        "Design, build, and maintain scalable data pipelines and ETL/ELT processes using Python and SQL.",
        "Develop and manage data models within our and clients' data warehouses (e.g., BigQuery, Fabric, Postgres, etc.).",
        "Ensure data quality, integrity, and reliability across our entire data infrastructure.",
        "Collaborate with data scientists and analysts to provide them with clean, accessible data.",
        "Implement automation for data processing tasks and workflows.",
        "Assist in managing and optimizing our cloud-based data platforms (AWS, Azure, Google Cloud).",
        "Document data sources, models, and transformations."
    ],
    qualifications: [
        "Bachelor's degree in Computer Science, Engineering, or a related field.",
        "Experience with data warehousing concepts and technologies (e.g., BigQuery, Fabric, Postgres, etc.).",
        "Proficiency in SQL and experience with a scripting language like Python.", 
        "Familiarity with ETL/ELT processes and tools.",
        "Basic knowledge of cloud services (AWS, Azure, Google Cloud).",
        "Excellent communication and collaboration skills.",
        "Experience with BigQuery and dbt is considered a strong plus."
    ]
  }
//   ,
//   {
//     id: "junior-sales",
//     title: "Junior Sales",
//     description: "Help us grow by connecting with new clients and partners who want to unlock business value from data.",
//     location: "Žilina, Slovakia or Remote in Slovakia or Czechia.",
//     contract: "Full Time, Contract",
//     introduction: {
//       title: "Welcome to Stratodata",
//       content: "We are a team of passionate data experts, technologists, and business strategists dedicated to helping our clients harness the power of their data. At Stratodata, you won't just be an employee; you'll be a pivotal part of our mission to drive innovation and create tangible value. We foster a culture of learning, collaboration, and impact. If you are driven by challenges and excited by the prospect of shaping the future of data analytics and AI, you've come to the right place."
//     },
//     hiringProcess: {
//       title: "Our Hiring Process",
//       steps: [
//         { title: 'Apply', description: 'Submit your CV. We review every application.' },
//         { title: 'First Interview', description: 'The Online interview with your future colleague.' },
//         { title: 'Take-home challenge', description: 'A practical assignment reflecting our work.' },
//         { title: 'Challenge Review', description: 'An Online chat with your future manager and colleagues about your take-home challenge.' },
//         { title: 'Second Interview', description: 'The Online interview with one of the founders to discuss your fit and future goals.' },
//         { title: 'Offer', description: "If it's a fit, we'll extend a warm welcome!" },
//       ]
//     },
//     responsibilities: [
//         "Identify and qualify new business opportunities through various channels.",
//         "Build and maintain relationships with prospective clients and partners.",
//         "Present our services and solutions to potential customers.",
//         "Collaborate with the technical team to develop proposals and quotes."
//     ],
//     qualifications: [
//         "Excellent communication and interpersonal skills.",
//         "A strong interest in technology and data.",
//         "Proven ability to learn quickly and adapt to new challenges.",
//         "Previous experience in a sales or customer-facing role is a plus."
//     ]
//   },
]; 